<template>
  <div class="purchaseproductlistPage">
    <XR-purchase-search-head mode="list" :key="this.$route.query.key"></XR-purchase-search-head>
    <v-scrollEvent :on-refresh="onRefresh" :on-infinite="onInfinite" :on-scrollEvent="scrollEvent" ref="scroll">
    <div class="sort-list" v-if="!loaded">
      <div :class="searchInfo.sort=='normal'?'sort-item select' :'sort-item' " @click="sortClick('normal')">
        <span>新品</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div :class="searchInfo.sort=='salecount'?'sort-item select' :'sort-item'" @click="sortClick('salecount')">
        <span>销量</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div :class="searchInfo.sort=='price'?'sort-item select' :'sort-item'" @click="sortClick('price')">
        <span>价格</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div class="sort-item sort-more" @click="open('right')">筛选</div>
      <mu-popup position="right" popupClass="retailproductlistCondition-popup" :style="{height:fullHeight+'px'}" :open="rightPopup" @close="close('right')">
        <div class="conditon-list" :style="{height: fullHeight-46+'px'}">
          <div class="retailproductlistcondition-title">          
            <div class="text">特色服务</div>
          </div>
          <div class="retailproductlistcondition-list">
            <div :class="'retailproductlistcondition-item ' + (this.searchInfo.isStock?'select':'')" @click="conditionService('stock')">仅看有货</div>
          </div>
          <div class="retailproductlistcondition-title">          
            <div class="text">属性搜索</div>
          </div>
          <mu-divider class="retailproductlistcondition-line" />

          <template v-for="attrItem in attrListResult">
            <div class="retailproductlistcondition-title">
              <div class="text">{{attrItem.AttrName}}</div>
              <div class="btn" @click="conditionBtnClick(attrItem.AttrId)"><i :class="currentAttrId == attrItem.AttrId? sizeBtnIcon: 'fa fa-angle-down'"></i></div>
            </div>
            <div class="retailproductlistcondition-list" :style="{height: getAttrHeight(attrItem.AttrId)}">
              <div :class="'retailproductlistcondition-item '+ getConditionCheckClassName(attrItem.AttrId,valueItem.AttrValueId)" @click="conditionValueClick(attrItem.AttrId,valueItem.AttrValueId,valueItem.AttrValue)" v-for="valueItem in attrItem.AttrValueList">
                {{valueItem.AttrValue}}
              </div>
            </div>
            <mu-divider class="retailproductlistcondition-line" />
            
          </template>
        </div>
        <div class="condition-button">
          <div class="cbutton condition-reset" @click="resetCondition('right')">重置</div>
          <div class="cbutton condition-yes" @click="conditionSearch('right')">确定</div>
        </div>
      </mu-popup>
    </div>
  
    <div class="product-list" v-if="!loaded && this.searchInfo.sort != 'shop'">
      <div class="product-item" v-for="pItem in productList" :key="pItem.SkuId">
        <router-link :to="'/wholesale/productDetail?skuId='+pItem.SkuId">
          <img :src="pItem.DefaultImg?pItem.DefaultImg: IMGServer_URL+'/images/index-item-default.png'" class="pro-img" />
          <div class="product-info" :style="{ width:proItemInfoWidth+'px'}">
            <p class="product-name">{{pItem.ProductName}}</p>
            <div class="active">            
              <p class="fontIcon integral" v-if="pItem.IsExchange>0">兑</p>
              <p class="fontIcon discount" v-if="pItem.IsDiscount>0">惠</p>
              <!-- <p class="fontIcon wua">WUA</p>        -->
            </div>
            <p class="shopInfo">
              <!-- <i class="fa fa-house1"></i> {{pItem.ShopName}} -->&nbsp;
            </p>
            <div class="saleinfo">
              <p class="price"><i class="fa fa-rmb"></i>{{pItem.PriceName}}</p>     
              <p class="saleCount">已售{{pItem.SaleCount}}</p>
            </div>
          </div>      
        </router-link>           
      </div>   
    </div>
    <div class="shop-list" v-if="!loaded && this.searchInfo.sort == 'shop'">
      <template v-for="sItem in shopList" >
        <router-link :to="'/shop/shopIndex?shopId='+sItem.ShopId" :key="sItem.ShopId">
          <div class="entrance">
            <div class="enceimg">
              <img :src="sItem.ShopLogo?sItem.ShopLogo:siteInfo.Logo" alt="">
            </div>
            <div class="store">
              <p style="font-size:14px;">{{sItem.ShopName}}</p>
              <p style="font-size:12px; color:#dedede;">{{sItem.ShopAreaName}}</p>
            </div>
            <div class="jian">
              <i class="fa fa-angle-right"></i>
            </div>
          </div>
        </router-link>        
        <div class="pro-list" :style="{height: prolistHeight+'px'}">          
            <div class="item-left" :style="{height: itemleftHeight+'px'}" 
            v-for="pItem2 in sItem.ProductList" :key="pItem2.SkuId">               
              <router-link :to="'/wholesale/productDetail?skuId='+pItem2.SkuId" :key="sItem.ShopId">
                <img  :src="pItem2.DefaultImg?pItem2.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" :style="{height: imgHeight+'px'}" class="pro-img" />                   
              </router-link>    
              <span :style="{left: leftWidth+'px'}" class="fa fa-rmb">{{pItem2.PriceName}}</span>
            </div>
        </div>    
      </template>
    </div>

    <div>
      <template v-if="hasData">
        <div class="qq_footer"><img class="jd_logo" id="jdBtmLogo" src=" ../static/refresh/more.png" />亲，暂无更多产品</div>
      </template>
      <template v-if="!loadData && !hasData">
          <div class="s_null" id="sNull01">
           <img style="width:30%;" src=" ../static/refresh/nomore.png" alt=""> 
            <p class="tip">亲，暂无更多产品！</p>
        </div>
      </template>
    </div>
    </v-scrollEvent>
    <mu-back-top>
      <mu-float-button icon=":fa fa-arrow-up" primary class="demo-float-button"/>
    </mu-back-top>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: true,
      rightPopup: false,
      Width: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-125),
      currentAttrId:0,
      sizeHeight : '102px',
      sizeBtnIcon: 'fa fa-angle-down',
      sortIcon: 'fa-angle-down',
      searchInfo:{
        key: this.$route.query.searchKey?this.$route.query.searchKey:'',
        categoryId: this.$route.query.categoryId?this.$route.query.categoryId:0,
        sort: window.localStorage.purchaseProductList_sort? window.localStorage.purchaseProductList_sort : 'normal',
        orderBy: window.localStorage.purchaseProductList_sortOrderBy?window.localStorage.purchaseProductList_sortOrderBy:true,
        isStock : false,
        isDiscount: false,
        brandIds : [],
        attrList: [],
        pageIndex:1
      },
      num:15,
      productList:[],
      shopList:[],
      attrListResult:[],
      pageEnd:0,
      scrollDone: function(){},
      hasData:false,
      loadData: true,
      siteInfo:[]
    }
  },
  mounted: function() {
    // if(this.searchInfo.sort == 'shop'){
    //   this.shopSearch(true)
    // }else{
      this.search(true)
    // }
    this.getSiteInfo()
  },
  methods: {
    open (position) {
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    },
    conditionSearch(position){
      this.close(position)
      this.searchInfo.sort = "normal"
      this.search(true)
    },
    resetCondition(position){
      this.close(position)
      this.searchInfo.isStock = false
      this.searchInfo.isDiscount = false
      this.searchInfo.attrList = []
      this.search(true)
    },
    conditionService(type){
      if(type == 'stock'){
        this.searchInfo.isStock = !this.searchInfo.isStock
      }else{
        this.searchInfo.isDiscount = !this.searchInfo.isDiscount
      }
    },
    getAttrHeight(id){
      return this.currentAttrId == id? this.sizeHeight: 'unset'
    },
    conditionBtnClick (id){
      if(this.currentAttrId != id){
        this.sizeHeight = 'unset'
        this.sizeBtnIcon = 'fa fa-angle-down'
      }
      
      this.currentAttrId = id 
      if(this.sizeHeight == 'unset'){        
        this.sizeHeight = '102px'
        this.sizeBtnIcon = 'fa fa-angle-up'
      }else{        
        this.sizeHeight = 'unset'
        this.sizeBtnIcon = 'fa fa-angle-down'
      }
    },
    sortClick(key){
      if(this.searchInfo.sort == key){
        this.searchInfo.orderBy = !this.searchInfo.orderBy
      }
      else{
        this.searchInfo.sort = key
        this.searchInfo.orderBy = true
      }
      
      window.localStorage.purchaseProductList_sort = this.searchInfo.sort
      window.localStorage.purchaseProductList_sortOrderBy = this.searchInfo.orderBy

      this.sortIcon = this.searchInfo.orderBy ? 'fa-angle-down':'fa-angle-up'

      if(this.searchInfo.sort == 'shop'){
        this.shopSearch(true)
      }else{
        this.search(true)
      }
    },
    search:function(isNewSearch){
      this.$refs.XRtoast.load()
      var ths = this;  

      if(isNewSearch){        
        this.searchInfo.pageIndex = 1
      }
      else{
        this.searchInfo.pageIndex++
      }
      
      var url = '/Shop/PurchaseServer/SearchCategoryProduct';
      if(ths.searchInfo.key){
        url = '/Shop/PurchaseServer/SearchKeyProduct'
      }
      ths.$post(
        url,
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded =false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.loadData = false
          ths.productList=[]
          if(ths.productList.length == 0){
            ths.hasData= false
          }else{
            ths.hasData= true
          }
          //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.searchComplate(isNewSearch,res.Data)
        }
      });
    },    
    searchComplate(isNewSearch,data){

      this.attrListResult = data.AttrList
      if(isNewSearch){
        this.productList = data.ProductList.List
      }
      else{        
        for(var i=0; i< data.ProductList.List.length; i++){
          this.productList.push(data.ProductList.List[i])
        }
      }
      this.pageEnd = data.ProductList.Rows % this.num !=0 ? parseInt(data.ProductList.Rows / this.num)+1:data.ProductList.Rows/ this.num
      if(this.pageEnd == this.searchInfo.pageIndex){
        this.hasData = true
        //this.$refs.scroll.infiniteDone()
      }
      this.$refs.XRtoast.hide()
    },
    shopSearch:function(isNewSearch){
      this.$refs.XRtoast.load()
      var ths = this;  
      if(isNewSearch){     
        this.searchInfo.pageIndex = 1
      }
      else{
        this.searchInfo.pageIndex++
      }
      
      var url = '/Shop/RetailServer/SearchShopProductList';
      ths.$post(
        url,
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded =false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shopSearchComplate(isNewSearch,res.Data)
        }
      });
    },    
    shopSearchComplate(isNewSearch,data){
      if(isNewSearch){
        this.shopList = data.List
      }
      else{        
        for(var i=0; i< data.List.length; i++){
          this.shopList.push(data.List[i])
        }
      }
      this.pageEnd = data.Rows% this.num!=0? data.Rows/ this.num+1:data.Rows/ this.num
      this.$refs.XRtoast.hide()
    },
    getConditionCheckClassName(attrId, attrValueId){
      for(var i = 0; i < this.searchInfo.attrList.length;i++){
        var attrItem = this.searchInfo.attrList[i]
        if(attrItem.attrId == attrId && attrItem.attrValueId == attrValueId){
          return 'select'
        }
      }
      return ''
    },
    conditionValueClick(attrId, attrValueId, attrValue){
      if(this.searchInfo.attrList.length==0){
        this.searchInfo.attrList.push({attrId:attrId, attrValueId:attrValueId})
        return
      }
      var attrList = []
      var currentAttr = {}
      for(var i = 0; i < this.searchInfo.attrList.length;i++){
        var attrItem = this.searchInfo.attrList[i]
        if(attrItem.attrId != attrId){
          attrList.push(attrItem)
        }else {
          currentAttr = attrItem
        }
      }

      if(currentAttr.attrValueId != attrValueId){
        attrList.push({attrId:attrId, attrValueId:attrValueId})
      }
      this.searchInfo.attrList = attrList
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        //this.$refs.XRtoast.failed("已经到底", true)
        this.$refs.scroll.infiniteDone()
        return
      }
      if(this.searchInfo.sort == 'shop'){
        this.shopSearch(false)
      }else{
        this.search(false)
      }
    },
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }    
  },
  computed: {
    prolistHeight:function(){
      return this.Width * 0.3+this.Width* 0.06      
    },
    imgHeight:function(){
      return this.Width * 0.94 * 0.32 * 0.9
    },
    itemleftHeight:function(){
      return this.Width * 0.3
    },
    leftWidth:function(){
      return (this.itemleftHeight-60)/2
    
    }
    
  }
};
</script>

<style>
 .purchaseproductlistPage #sNull01{
   text-align: center;
   padding: 10px;
   padding-top: 40px;
    color: #999;
    height: 195px;
 }
 .s_null .tip {
    margin-bottom: 15px;
    line-height: 1;
    font-size: 12px;
    color: #aaa;
    text-align: center;
}
.purchaseproductlistPage .sort-list{
  overflow: hidden;
  background: white;
}
.purchaseproductlistPage .sort-list .sort-item{
  overflow: hidden;
  line-height: 40px;
  width: 25%;
  text-align: center;
  float: left;
}
.purchaseproductlistPage .sort-list .sort-item .fa{
  display: none;
}
.purchaseproductlistPage .sort-list .sort-item.sort-more{
  width: 20%;
  float: right;
}
.purchaseproductlistPage .sort-list .sort-item.select{
  color:red;
}
.purchaseproductlistPage .sort-list .sort-item.select .fa{
  display: inline;
}
.retailproductlistCondition-popup{  
  width: 80%;
  height: 100%;
  max-width: 375px;
  align-items: center;
  padding: 10px;
}
.retailproductlistCondition-popup .retailproductlistcondition-line{  
  margin: 10px 0;
}
.retailproductlistCondition-popup .conditon-list{ 
  overflow-y: scroll;
}
.retailproductlistCondition-popup .retailproductlistcondition-title{ 
  overflow: hidden;
  padding-bottom: 10px;
}
.retailproductlistCondition-popup .retailproductlistcondition-title .text{ 
  float: left;
  color:black;
}
.retailproductlistCondition-popup .retailproductlistcondition-title .btn{ 
  float: right;
}
.retailproductlistCondition-popup .retailproductlistcondition-list{ 
  overflow: hidden;  
  height: 102px;
}
.retailproductlistCondition-popup .retailproductlistcondition-item{ 
  float: left;
  width:30%;
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 3.33%;
  margin-bottom: 10px;
  text-align: center;
  background: #F0F2F5;
  border-radius: 4px;
}
.retailproductlistCondition-popup .retailproductlistcondition-item.select{ 
  background: red;
  color:white;
}


.purchaseproductlistPage .product-list{
  overflow: hidden;
  margin-top: 5px;
  border-bottom:1px solid #eee;
  background: white;
}
.purchaseproductlistPage .product-list .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px 0;
  height: 126px;
}
.purchaseproductlistPage .product-list .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.purchaseproductlistPage .product-list .product-item a{  
  color:black;
}
.purchaseproductlistPage .product-list .product-item .pro-img{
  width: 105px;
  float: left;
  background: white;
  max-height: 105px;
}
.purchaseproductlistPage .product-list .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 85px;
}
.purchaseproductlistPage .product-list .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 32px;
  font-size: 14px;
  padding-bottom: 10px;
}

.purchaseproductlistPage .product-list .product-item  .product-info .active{
  overflow: hidden;
  height: 26px;
}
.purchaseproductlistPage .product-list .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  background: red;
  text-align: center;
  color:white;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 6px 1px;
}
.purchaseproductlistPage .product-list .product-item  .product-info .active .wua{
  width: 34px;
  height: 14px;
}

.purchaseproductlistPage .product-list .product-item  .shopInfo{
  overflow: hidden;
  line-height: 16px;
  height: 16px;
  font-size: 12px;
  margin-top: 4px;
}
.purchaseproductlistPage .product-list .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
  margin-top: 10px;
}
.purchaseproductlistPage .product-list .product-item  .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  float: left;
  font-size: 16px;
  color:Red;
  padding-right: 10px;
}
.purchaseproductlistPage .product-list .product-item  .product-info .saleinfo .price .fa{
  font-size: 12px;
  margin-right: 5px;
}
.purchaseproductlistPage .product-list .product-item  .product-info .saleinfo .saleCount{
  float: right;
  color:#ccc;
}


.purchaseproductlistPage .shop-list{

}
.purchaseproductlistPage .shop-list .shop-item{
  
}
.purchaseproductlistPage .shop-list .shop-item .shop-info{
  
}
.purchaseproductlistPage .shop-list .shop-item .shop-product-list{
  
}
.purchaseproductlistPage .shop-list .shop-item .shop-product-list{
  overflow: hidden;
}
.purchaseproductlistPage .shop-list .shop-item .shop-product-list .shop-product-item{
  width:33.33%;
  float: left;
}
.purchaseproductlistPage .shop-list .shop-item .shop-product-list .shop-product-item .pro-img{
  width: 100%;
}
.purchaseproductlistPage .shop-list .shop-item .shop-product-list .shop-product-item .pro-price{
  
}

.purchaseproductlistPage .shop-list .entrance{
  margin-top: 5%;
  height: 100px;
  padding: 0 3%;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #dedede;
}
.purchaseproductlistPage .shop-list .enceimg{
  float: left;
  width: 20%;
  height: 100%;
   display: flex;
  align-items: center;  
  justify-content: center;
}
.purchaseproductlistPage .shop-list .enceimg img{
  width: 100%;
  max-height: 90%;
}
.purchaseproductlistPage .shop-list .store{
  width: 60%;
  height: 100%;
  padding: 3% 1%;
  float: left;
}
.purchaseproductlistPage .shop-list .jian{
  width: 20%;
  height: 100%;
  text-align: center;
  padding: 5% 0;
  float: left;
}
.purchaseproductlistPage .shop-list .jian img{
  width: 15px;
  height: 10px;

}
.purchaseproductlistPage .shop-list .pro-list{
  overflow: hidden;
  width: 100%; 
  padding: 3% 3% 0 3%;
  background: #fff;
}
.purchaseproductlistPage .shop-list .pro-list .item-left{
  float: left;
  width: 32%;
  text-align: center;
  background-size: cover;
  position: relative;
}
.purchaseproductlistPage .shop-list .pro-list .item-left img{
  width: 90%;
}
.purchaseproductlistPage .shop-list .pro-list .item-left span{
  background: #f19500;
  color: white;
  padding:  0 2%;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 3px;
  left: 30px;
}






.retailproductlistCondition-popup .condition-button{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  text-align: center;
  line-height: 46px;
}
.retailproductlistCondition-popup .condition-button .cbutton{
  float: left;
  width: 50%;
  border-top:1px solid #eee;
  background: white;
}
.retailproductlistCondition-popup .condition-button .condition-yes{
  background: red;
  border-top:1px solid #eee;
  color:white;
}
.purchaseproductlistPage .product-list{
  border:0;
}
  
  
 .s_empty {
    text-align: center;
    height: 100px;
    line-height: 100px;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/wholesale/productList.vue